import React from "react";
import { CheckCircle, AlertCircle, X } from "lucide-react";

interface AlertBannerProps {
  alert: { type: "success" | "error"; message: string } | null;
  onClose: () => void;
}

export const AlertBanner: React.FC<AlertBannerProps> = ({ alert, onClose }) => {
  if (!alert) return null;

  return (
    <div
      className={`p-4 rounded-lg flex items-center justify-between ${
        alert.type === "success" ? "bg-green-50 border border-green-200" : "bg-red-50 border border-red-200"
      }`}
    >
      <div className="flex gap-3 items-center">
        {alert.type === "success" ? (
          <CheckCircle className="w-5 h-5 text-green-600" />
        ) : (
          <AlertCircle className="w-5 h-5 text-red-600" />
        )}
        <p className={alert.type === "success" ? "text-green-800" : "text-red-800"}>{alert.message}</p>
      </div>
      <button onClick={onClose}>
        <X className="w-5 h-5 text-gray-500" />
      </button>
    </div>
  );
};
